import X from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/node_modules/.pnpm/lucide-react@1.61.0_@types+react@18.3.31_react@18.3.1/node_modules/lucide-react/dist/esm/icons/x.mjs";
import { useSyncExternalStore } from "react";

import { cx } from "../cx";
import { dismissToast, getToasts, subscribeToasts } from "./toast";

export interface ToasterProps {
  /** Accessible name of the close button ("Cerrar" / "Close"), from the app catalog. */
  dismissLabel: string;
  /** Accessible name of the region ("Notificaciones" / "Notifications"). */
  regionLabel: string;
  /** Lift the toasts above the bottom nav on < 900 px. */
  aboveBottomNav?: boolean;
}

/** The single global toast region (FE-01 FR-FE01-28). */
export function Toaster({ dismissLabel, regionLabel, aboveBottomNav = false }: ToasterProps) {
  const items = useSyncExternalStore(subscribeToasts, getToasts, getToasts);
  return (
    <section
      aria-label={regionLabel}
      className={cx(
        "pointer-events-none fixed inset-x-0 z-[60] flex flex-col items-center gap-2 px-4",
        aboveBottomNav
          ? "bottom-[calc(84px+env(safe-area-inset-bottom))] lg:bottom-6"
          : "bottom-[calc(24px+env(safe-area-inset-bottom))]",
      )}
    >
      {items.map((t) => (
        <div
          key={t.id}
          role={t.tone === "error" ? "alert" : "status"}
          className="pointer-events-auto flex w-full max-w-[min(92vw,480px)] items-center gap-3 rounded-lg bg-toast-bg py-2 pr-2 pl-4 text-toast-text shadow-popover"
        >
          <p className="min-w-0 flex-1 py-1">{t.message}</p>
          {t.action ? (
            <button
              type="button"
              className="min-h-12 shrink-0 rounded-full px-3 font-semibold underline"
              onClick={() => {
                t.action?.onClick();
                dismissToast(t.id);
              }}
            >
              {t.action.label}
            </button>
          ) : null}
          <button
            type="button"
            aria-label={dismissLabel}
            className="inline-flex size-12 shrink-0 items-center justify-center rounded-full"
            onClick={() => dismissToast(t.id)}
          >
            <X aria-hidden="true" size={18} />
          </button>
        </div>
      ))}
    </section>
  );
}
